import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';
import {Observable} from 'rxjs';
import {BrandingContact, BrandingData, BrandingLegal, BrandingResponse} from '../../shared/models/branding.model';
import {map} from 'rxjs/operators';
import {API_CONFIG} from './api.config';
import {ThemeDTO} from '../../shared/models/theme.model';

@Injectable({providedIn: 'root'})
export class BrandingService {
  constructor(
    private http: HttpClient,
    private cache: HttpCacheService
  ) {
  }

  getBranding(brandingCode: string): Observable<BrandingData> {
    const key = `BrandingService:GET:environment=${brandingCode}`;

    return this.cache.getOrSet<BrandingData>(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () =>
        this.http.get<BrandingResponse>(`${API_CONFIG.apiBaseUrl}${API_CONFIG.getBrandingPath(brandingCode)}`).pipe(
          map((response: BrandingResponse) => response.data)
        )
    );
  }

  getBrandingTheme(brandingCode: string): Observable<ThemeDTO> {
    return this.getBranding(brandingCode).pipe(
      map((data: BrandingData) => ({
        componentColor: data.branding.color,
        componentColorLight: data.branding.secondary_color,
        textColor: data.branding.color,
        textColorLight: data.branding.secondary_color,
        pathLogo: data.branding.logo,
        pathBackground: data.branding.image
      }))
    );
  }

  getBrandingLegal(brandingCode: string): Observable<BrandingLegal> {
    return this.getBranding(brandingCode).pipe(
      map((data: BrandingData) => data.legal)
    );
  }

  getBrandingContact(brandingCode: string): Observable<BrandingContact> {
    return this.getBranding(brandingCode).pipe(
      map((data: BrandingData) => data.contact)
    );
  }
}
